import React, { useState, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { StateSelect } from '../../util';
import { FormControl } from 'react-bootstrap';
export const WagesRow = _ref => {
  let {
    showTypeAndYear = false,
    index,
    claim,
    claimEmployees,
    setClaimEmployees,
    refreshClaim,
    claimEmployeesService,
    handleError
  } = _ref;
  const claimEmployee = useMemo(() => {
    return {
      ...claimEmployees[index]
    };
  }, [claimEmployees, index]);
  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch();
  const updateEmployees = useCallback(employee => {
    const newEmployees = [...claimEmployees];
    newEmployees[index] = {
      ...employee
    };
    setClaimEmployees([...newEmployees]);
  }, [claimEmployees, index, setClaimEmployees]);
  const handleChange = useCallback(async event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    claimEmployee[event.target.name] = value;
    await updateEmployees(claimEmployee);
  }, [updateEmployees, claimEmployee]);
  const saveChange = useCallback(() => {
    let method;
    if (claimEmployee.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimEmployeesService[method](claimEmployee).then(updatedEmployee => {
      setHasError(false);
      updateEmployees(updatedEmployee);
      refreshClaim();
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [claimEmployee, claimEmployeesService, updateEmployees, refreshClaim, dispatch, handleError]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, claimEmployee.name), /*#__PURE__*/React.createElement("div", {
    className: "text-muted"
  }, claimEmployee.number ? `${claimEmployee.number}` : null))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked,
    name: "sum_agree_working_hours",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked,
    name: "relevant_working_hours",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: true,
    name: "share_of_working_time",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked,
    name: "excluding_special_payments",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked,
    name: "sum_of_special_payments",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: true,
    name: "sum_gross_wages",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked,
    name: "social_security_contributions",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: true,
    name: "gross_wages",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: true,
    name: "working_time_social_security_contributions",
    type: "text",
    size: "sm"
  }))));
};